module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "good-item"
  }, [_c('div', {}, [_c('div', {
    staticClass: "good-img"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openProduct(_vm.msg.id)
      }
    }
  }, [_c('img', {
    key: _vm.msg.defaultImage,
    attrs: {
      "src": _vm.msg.defaultImage,
      "alt": _vm.msg.name
    }
  })])]), _vm._v(" "), _c('h6', {
    staticClass: "good-title",
    domProps: {
      "innerHTML": _vm._s(_vm.msg.name)
    }
  }, [_vm._v(_vm._s(_vm.msg.name))]), _vm._v(" "), _c('div', {
    staticClass: "good-price pr"
  }, [_c('div', {
    staticClass: "ds pa"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.openProduct(_vm.msg.id)
      }
    }
  }, [_c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "查看详情"
    }
  })], 1), _vm._v(" "), _c('y-button', {
    staticStyle: {
      "margin": "0 5px"
    },
    attrs: {
      "text": "加入购物车",
      "classStyle": "main-btn"
    },
    on: {
      "btnClick": function($event) {
        return _vm.showModal(_vm.msg.id, _vm.msg.settlementPrice, _vm.msg.name, _vm.msg.defaultImage, _vm.msg.frontendPropertyInfo, _vm.msg.productSpecs)
      }
    }
  })], 1), _vm._v(" "), _c('p', [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("采购价：￥")]), _vm._v(_vm._s(Number(_vm.msg.settlementPrice).toFixed(2)))]), _vm._v(" "), _c('h5', {
    staticStyle: {
      "font-size": "14px",
      "color": "#bdbdbd"
    }
  }, [_vm._v("原价：￥" + _vm._s(Number(_vm.msg.sellPrice).toFixed(2)))])])]), _vm._v(" "), (_vm.showSpecModal) ? _c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-title"
  }, [_vm._v("请选择规格")]), _vm._v(" "), _c('div', {
    staticClass: "proper-box"
  }, _vm._l((_vm.msg.frontendPropertyInfo), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "proper"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "items"
    }, _vm._l((item.propertyDetails), function(p, j) {
      return _c('div', {
        key: j,
        class: ["item", p.current ? "active" : "1"],
        on: {
          "click": function($event) {
            return _vm.selAttr(i, j)
          }
        }
      }, [_vm._v(" " + _vm._s(p.name))])
    }), 0)])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "num-box"
  }, [_c('span', {
    staticClass: "params-name"
  }, [_vm._v("数量")]), _vm._v(" "), _c('buy-num', {
    attrs: {
      "limit": Number(_vm.stockNum)
    },
    on: {
      "edit-num": _vm.editNum
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "anniu"
  }, [_c('y-button', {
    staticStyle: {
      "background": "#f9f9f9",
      "border": "1px solid #f9f9f9",
      "color": "#000"
    },
    attrs: {
      "text": "取消",
      "classStyle": "main-btn "
    },
    on: {
      "btnClick": function($event) {
        return _vm.close()
      }
    }
  }), _vm._v(" "), _c('y-button', {
    attrs: {
      "text": "确认",
      "classStyle": "main-btn "
    },
    on: {
      "btnClick": function($event) {
        return _vm.addSpecCart(_vm.msg.id, _vm.msg.settlementPrice, _vm.msg.name, _vm.msg.defaultImage)
      }
    }
  })], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d44e1ab0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mallGoods.vue
// module id = 783
// module chunks = 2